// extracted by mini-css-extract-plugin
module.exports = {"footerListItem":"styles_footerListItem__8J0fh","link":"styles_link__j6hXT","linkBlock":"styles_linkBlock__CnILy"};